import { GoabButton, GoabButtonGroup, GoabCircularProgress, GoabDropdown, GoabDropdownItem, GoabIcon, GoabModal, GoabSpacer, GoabTextArea } from "@abgov/react-components";
import * as yup from "yup"
import './userDetails.scss'
import { useCallback, useContext, useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import ApiService from "../../../services/ApiService";
import { InferType } from "yup";
import { CustomFmF } from "../../../components/datePicker/datePicker";
import { Toast } from "../../../components/toast/toast";
import { Autocomplete, FormControlLabel, Radio, RadioGroup, TextField } from "@mui/material";
import { useFormik } from "formik";
import { useAuth } from "react-oidc-context";
//import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
//import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs, { Dayjs } from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
//import { utcToZonedTime, zonedTimeToUtc } from 'date-fns-tz';
import { wdpUtil } from "../../../common/utils/util";
import { appStrings, tz } from "../../../common/constants";
import { AppContext } from "../../../contexts/apiContext";
import { GoabCalloutSize, GoabCalloutType, GoabDropdownOnChangeDetail, GoabTextAreaOnChangeDetail } from "@abgov/ui-components-common";

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.tz.setDefault(tz);



const emailRegex = /^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
const displayNameRegex = /^([a-zA-Z0-9]){1,15}$/;
const getUserSchema = (token: string) => {
  const userSchema = yup.object().shape({
    id: yup.number(),
    userId: yup.string(),
    createdByUserId: yup.number().nullable(),
    createdOn: yup.date().nullable(),
    createdByEmail: yup.string().nullable(),
    createdByDisplayName: yup.string().nullable(),
    updatedOn: yup.date().nullable(),
    updatedByEmail: yup.string().nullable(),
    updatedByDisplayName: yup.string().nullable(),
    updatedByUserId: yup.number().nullable(),
    //createdTimestamp: yup.number(),
    firstName: yup.string().required("Cannot be empty. Enter first name."),
    lastName: yup.string().required("Cannot be empty. Enter last name."),
    emailUnique: yup.bool(), // this is to work as state variable to maintain the uniqueness of the entered email
    displayNameUnique: yup.bool(), // this is to work as state variable to maintain the uniqueness of the entered/suggested displayName
    email: yup.string().email("The entered value is not a valid email")
      .matches(emailRegex, "The entered value is not a valid email")
      .test(
        'is-duplicate-email',
        'An account with this email already exists. Use another email address.',
        (value, context) => {
          const isUnique = (context?.from || [{}])[0]?.value?.emailUnique;
          return isUnique;
        }
      )
      .required("Cannot be empty. Enter email address."),
    phone: yup.string(),
    middleName: yup.string(),
    displayName: yup.string()
      .required("Cannot be empty. Enter a Display name which contains only letters and numbers, maximum 15 characters.")
      .test(
        'length-and-non-alphanumeric',
        'Display name can contain only letters and numbers, maximum 15 characters.',
        (value, context) => {
          const isValidDisplaName = displayNameRegex.test(value || '');
          return isValidDisplaName;
        }
      )
      .test(
        'is-duplicate-displayName',
        'An account with this display name already exists. Use another display name.',
        (value, context) => {
          const isUnique = (context?.from || [{}])[0]?.value?.displayNameUnique;
          return isUnique;
        }
      ),
    organization: yup.string().required("Cannot be empty. Enter organization name."),
    remarks: yup.string(),
    localGovernmentId: yup.number().nullable(),
    usernameAdministeredBy: yup.string().required("Cannot be empty. Select an appropriate area."),
    accessEnded: yup.string(),
    accessStartDate: yup.string().typeError(appStrings.validate_dt_invalid)
      .nullable()
      .required(appStrings.validate_access_sdt_empty)
      .test(
        'is-less-than-endDate',
        appStrings.validate_access_sdt_beforeOrSameEdt,
        (value, context) => {

          const asDt = (value ? dayjs(value).tz().startOf('day') : null);
          const aeDt = wdpUtil.isNullorUndefined(context.parent.accessEndDate) ? null : dayjs(context.parent.accessEndDate).tz().endOf('day');
          const isLess = !aeDt || asDt! <= aeDt;
          return isLess;

        }
      )
      .test(
        'is-greater-than-today',
        appStrings.validate_dt_past,
        (value, context) => {
          context.from = context.from || [];
          const id = context.from[0]?.value.userId;
          let isTodayOrLater = true;
          if (id === "new") {
            const todayDt = dayjs().tz().startOf('day');
            const asDt = dayjs(value).tz().startOf('day');
            isTodayOrLater = (asDt >= todayDt);

          }
          return isTodayOrLater;
        }
      )
    ,
    accessEndDate: yup.string().typeError(appStrings.validate_dt_invalid)
      .nullable()
      .test(
        'is-greater-than-startDate',
        appStrings.validate_access_edt_todayOrLaterSdt,
        (value, context) => {
          if (!value) return true;
          const aeDt = dayjs(value).tz().endOf('day');
          const asDt = wdpUtil.isNullorUndefined(context.parent.accessStartDate) ? null : dayjs(context.parent.accessStartDate).tz().startOf('day');

          const isGreater = !asDt || aeDt >= asDt;

          context.from = context.from || [];
          const id = context.from[0]?.value.userId;
          let isTodayOrLater = true;
          if (id === "new") {
            const todayDt = dayjs().tz().startOf('day');
            const aeDt = dayjs(value).tz().endOf('day');
            isTodayOrLater = (aeDt >= todayDt);
          }
          return isTodayOrLater && isGreater;
        }
      ),
  }, [["accessStartDate", "accessEndDate"]]);

  return userSchema;
};
var schema = getUserSchema('');
type UserInfo = InferType<typeof schema>;
const initialValues: UserInfo = {
  userId: "",
  firstName: "",
  lastName: "",
  email: "",
  emailUnique: true,
  displayNameUnique: true,
  accessStartDate: "",
  accessEndDate: "",
  phone: "",
  middleName: "",
  displayName: "",
  organization: "",
  remarks: "",
  localGovernmentId: null,
  usernameAdministeredBy: "",
  accessEnded: "No",
}

export function UserDetails(props: { currUser: any | null, userHasMunicipalRole: boolean,onUserUpdate:any }) {
  const auth = useAuth();
  const [showCancelModal, setShowCancelModal] = useState(false);
  const [localGovInputValue, setlocalGovInputValue] = useState('');  // this is for mui autoComplete..

  const onSubmit = (data: any) => {
    if (props.userHasMunicipalRole && !data.localGovernmentId) {
      handleToastOpen("Local government is required for users with municipal roles.", "emergency");
      return;
    }
    const email = data.email;
    const dName = data.displayName;

    ApiService.isDisplayNameExist(auth.user?.access_token!, dName, data.userId!).then(exist => {
      formik.setFieldValue('displayNameUnique', !exist);
      if (!exist) {
        if (userId === 'new') {
          ApiService.isEmailExist(auth.user?.access_token!, email).then(exist => {
            formik.setFieldValue('emailUnique', !exist);
            if (!exist) {
              execSubmit(data);
            }
          });
        } else {
          execSubmit(data);
        }
      }
    });
  }
  const execSubmit = (data: any) => {
    // trans. Save localGov as string too.. this is just for sorting 
    data.localGovernment = myAppCtx?.localGovsList.find(i => i.id === data?.localGovernmentId)?.description;

    // reset touched
    formik.setTouched({}, false);

    setProgressMsg("Submitting user info ...");
    if (userId === 'new') {
      data.accessEndDate = (wdpUtil.isNullorUndefined(data.accessEndDate) || data.accessEndDate.length === 0) ? null : data.accessEndDate;
      data.username = data.email;
      // check Display Name uniqunes
      ApiService.addUser(auth.user?.access_token as string, data).then(res => {
        formik.setSubmitting(false);
        // Samer in case of null
        if (!wdpUtil.isNullorUndefined(res)) {
          //console.log(res);
          reloadById.current = res.userId;
          handleToastOpen("New user created successfully");
        }
        else {
          // backend failed
          handleToastOpen("failed to create new user", "emergency");
        }
      }).catch((error) => {
        console.log(error);
        setProgressMsg("");
        handleToastOpen(`failed to create new user. ${error?.response?.data}`, "emergency");
      }).finally(() => { setProgressMsg(""); });
    } else {
      //data.accessEndDate =  (data.accessEndDate ? zonedTimeToUtc(startOfDay(data.accessEndDate),tz)!.toISOString() : null);
      data.accessEndDate = (wdpUtil.isNullorUndefined(data.accessEndDate) || data.accessEndDate.length === 0) ? null : data.accessEndDate;
      ApiService.updateUser(auth.user?.access_token as string, userId as string, data).then(res => {
        formik.setSubmitting(false);
        reloadById.current = userId as string;
        handleToastOpen("User updated successfully");
      }).catch((error) => {
        console.log(error);
        setProgressMsg("");
        handleToastOpen(`failed to update user. ${error?.response?.data}`, "emergency");
      }).finally(() => { setProgressMsg(""); });
    }
  }
  const getSchema = useCallback(() => {
    return getUserSchema(auth.user?.access_token as string);
  }, [auth.user?.access_token]);
  const formik = useFormik({
    initialValues,
    validationSchema: getSchema(),
    onSubmit: onSubmit
  });
  const reloadById = useRef('');
  const [progressMsg, setProgressMsg] = useState("");

  const { userId } = useParams();
  const navigate = useNavigate();
  // Toast
  const [toastOpen, setToastOpen] = useState(false);
  const [toastProp, setToastprop] = useState<{ msg: string, type: GoabCalloutType, size: GoabCalloutSize, trigger?: string }>({ msg: "test", type: "success", size: "medium" });

  const [showModal, setShowModal] = useState({ cb: (cancelled = true) => { }, show: false });
  const [displayNameSuggEnable, setDisplayNameSuggEnable] = useState(true);

  // context Data
  const myAppCtx = useContext(AppContext);
  /****************************************************************************************
   * 
  *****************************************************************************************/
  const handleToastOpen = (_msg: string, _type: GoabCalloutType = "success", size: GoabCalloutSize = "medium", _trigger?: string) => {
    setToastprop({ msg: _msg, type: _type, size, trigger: _trigger });
    setToastOpen(true);
  };
  /****************************************************************************************
   * 
  *****************************************************************************************/
  const handleToastClose = () => {
    setToastOpen(false);
    // navigate agian to this page..NOTE: parent will reload the info from the backend
    //use redirectId as a flag to tell that we are done Saving new User or Updaing an existing one

    // are we here because of submit() Save or update)?
    if (reloadById.current) {
      // was it submit a new user ?
      if (userId === 'new') {
        navigate(`/user-ctrl/${reloadById.current}`);
      }
      else {
        // was it update user ?
        //navigate(0);
        // no need to force navigation, becuase that will reload and reset context data. instead we can just pass the new info the parent Componenet and re query the user agian
        refresh();
      }
      reloadById.current = "";
    }
  };
  /****************************************************************************************
   *  data loading logic:
   *  - parent is quering from the backend by ID and pass the userInfo Object here in currUser Props
   *  - in case of userId is 'new', the currUser will be null
   *  - here we take care of submit (create and update) and then we ask the browser to navigate to the new user. if new
   *    or we call our function refresh to re query the userInfo and send a copy the parent to update itself (name, last name in thew header)
  *****************************************************************************************/
  useEffect(() => {
    if ( props.currUser !== null && userId !== 'new') {
      // if we have currUser then for sure userID is not 'new' 
      // ready to populate
      populateForm(props.currUser);
    }
    else{
      formik.setFieldValue("userId", "new");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  /****************************************************************************************
   * 
  *****************************************************************************************/
  function refresh() {
    if (userId !== 'new') {
      setProgressMsg("Loading user's details...");
      ApiService.getUsersById(auth.user?.access_token as string, userId as string).then(values => {
        const user = values || null;
        setProgressMsg("");

        // ready to populate
        populateForm(user);

        // inform the parent componenet about the new info.. mainly for the Title section (user name and last name and stuff)
        if (typeof props.onUserUpdate === "function") {
          props.onUserUpdate(user as UserInfo);
        }
      }).catch((error) => {
        console.log(error);
        setProgressMsg("");
      }).finally(() => { setProgressMsg(""); });
    }
  }
  /****************************************************************************************
   * 
  *****************************************************************************************/
  useEffect(() => {
    const el = document.querySelector('.Mui-error, [data-error]');
    if (!wdpUtil.isNullorUndefined(el)) {
      (el?.parentElement ?? el)?.scrollIntoView();
      (el?.firstChild as HTMLElement).focus();
    }
  }, [formik.isSubmitting]);
  /********************************************************************************************
   * 
  
  ********************************************************************************************/
  function populateForm(res: UserInfo | null) {
    if (res !== null) {
      formik.setFieldValue("userId", res.userId);
      formik.setFieldValue("id", res.id);
      formik.setFieldValue("createdOn", res.createdOn);
      formik.setFieldValue("createdByEmail", res.createdByEmail);
      formik.setFieldValue("createdByDisplayName", res.createdByDisplayName);
      formik.setFieldValue("createdByUserId", res.createdByUserId);
      formik.setFieldValue("updatedOn", res.updatedOn);
      formik.setFieldValue("updatedByEmail", res.updatedByEmail);
      formik.setFieldValue("updatedByDisplayName", res.updatedByDisplayName);
      formik.setFieldValue("updatedByUserId", res.updatedByUserId);
      formik.setFieldValue("email", res.email);
      formik.setFieldValue('emailUnique', true); // loading an existing user ...must be unique

      formik.setFieldValue("firstName", res.firstName ?? '');
      formik.setFieldValue("middleName", res.middleName ?? "");
      formik.setFieldValue("lastName", res.lastName ?? '');

      formik.setFieldValue("accessStartDate", res.accessStartDate ?? null);
      formik.setFieldValue("accessEndDate", res.accessEndDate ?? null);
      formik.setFieldValue("phone", res.phone ?? "");

      formik.setFieldValue("organization", res.organization ?? "");
      formik.setFieldValue("remarks", res.remarks ?? "");
      formik.setFieldValue("usernameAdministeredBy", res.usernameAdministeredBy ?? "");
      formik.setFieldValue("localGovernmentId", res.localGovernmentId ?? null);
      formik.setFieldValue("accessEnded", res.accessEnded !== "Yes" ? "No" : res.accessEnded);

      let dName = res.displayName;
      if (wdpUtil.isNullorUndefined(dName) || dName?.length === 0) {
        // auto populate Display Name (if null)
        dName = suggestDisplayName(res?.firstName, res?.middleName, res?.lastName);
      } else {
        // turn Off DisplayName suggestion 
        setDisplayNameSuggEnable(false);
      }
      // check if   unique ?
      if (!wdpUtil.isNullorUndefined(dName) && dName?.length) {
        ApiService.isDisplayNameExist(auth.user?.access_token!, dName, res.userId!).then(exist => {
          formik.setFieldValue('displayNameUnique', !exist);
        });
      }
      // populate it
      formik.setFieldValue("displayName", dName)
    }
  }
  /********************************************************************************************
   * 
   * this Effect is just to populate the DisplayName from FNamelastName,Mid Name 
  ********************************************************************************************/
  useEffect(() => {
    if (displayNameSuggEnable) {
      const sugDName = suggestDisplayName(formik.values.firstName, formik.values.middleName, formik.values.lastName);
      if (sugDName !== formik.values.displayName) {
        formik.setFieldValue("displayName", sugDName);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formik.values.firstName, formik.values.middleName, formik.values.lastName]);
  /********************************************************************************************
   * 
   * @param name 
   * @param value 
   *******************************************************************************************/
  function onNamesBlur() {
    const sugDName = formik.values.displayName;
    const isValidDisplaName = displayNameRegex.test(sugDName || '');
    if (isValidDisplaName) {
      ApiService.isDisplayNameExist(auth.user?.access_token!, sugDName, formik.values.userId!).then(exist => {
        formik.setFieldValue('displayNameUnique', !exist);
      })
    }
  }
  function onEmailBlur() {
    const email = formik.values.email;
    const isValidEmail = emailRegex.test(email || '');
    if (isValidEmail) {
      ApiService.isEmailExist(auth.user?.access_token!, email).then(exist => {
        formik.setFieldValue('emailUnique', !exist);
      })
    }
  }
  /****************************************************************************************************************
   * this function will populate the display name field with a suggested name based on the 
   * following formula: 7 chars of First name, 1st char of Middle name, 7 chars of Last name: 7+1+7.
   ****************************************************************************************************************/
  function suggestDisplayName(fname: string, mname: string | undefined, lname: string) {
    let sugVal = '';
    fname = fname || '';
    mname = mname || '';
    lname = lname || '';

    // strip the special characters 
    if (fname) {
      fname = fname.replace(/[^a-zA-Z0-9]/g, '');
    }
    if (mname) {
      mname = mname.replace(/[^a-zA-Z0-9]/g, '');
    }
    if (lname) {
      lname = lname.replace(/[^a-zA-Z0-9]/g, '');
    }

    const fnamePart = fname ? (fname.length >= 7 ? fname.slice(0, 7) : fname) : '';
    const mnamePart = mname ? mname[0] : '';
    const lnamePart = lname.slice(0, 7);

    if (fnamePart && lnamePart) {
      sugVal = `${fnamePart}${mnamePart}${lnamePart}`;
    }
    return sugVal;
  }
  const setFieldValueSync = async (name: string, value: string, touched?: boolean) => {
    formik.setFieldValue(name, value);
    if (!wdpUtil.isNullorUndefined(touched)) {
      // this is to trigger the validation on the new value so we need to wait till setFieldValue is done. 
      // setFieldValue callback is not working (cant do '.then') that is why we will use setTimeout.
      // with 0 delay we are waiting for the call stack to be empty in order to execute the callback.
      setTimeout(() => { formik.setFieldTouched(name, true); });
    }
  };
  /********************************************************************************************
   * 
   * @param fieldName 
   * @param value 
  *********************************************************************************************/
  function onDateChange(event: any) {
    //console.log(value);
    const who = event.target.name;
    let dt: Dayjs | null = event.target.value;
    const validDt = (dt !== null && !isNaN(dt.toDate().getTime()));


    let dtStr: any = null;
    if (who === 'accessStartDate')
      dtStr = validDt ? dayjs.utc(dayjs(dt).tz().startOf('day')).toISOString() : null;
    if (who === 'accessEndDate')
      dtStr = validDt ? dayjs.utc(dayjs(dt).tz().endOf('day')).toISOString() : null;

    formik.setFieldValue(who, dtStr, true);
    //formik.handleChang();
  }
  /********************************************************************************************
   * 
   * @param event
  *********************************************************************************************/
  function onDateBlur(event: any) {
    formik.handleBlur(event);
  }
  /********************************************************************************************
   * 
   * @param fieldName 
  *********************************************************************************************/
  function populateDT(fieldName: string) {
    //samerconst aDt       = (fieldName === "accessStartDate")? (formik.values.accessStartDate? utcToZonedTime(formik.values.accessStartDate,tz) : null): (formik.values.accessEndDate? utcToZonedTime(formik.values.accessEndDate,tz) : null)
    const dtStr = fieldName === "accessStartDate" ? formik.values.accessStartDate : formik.values.accessEndDate;

    const aDt = (dtStr ? dayjs(dtStr).tz() : null);
    const aTouched = (fieldName === "accessStartDate") ? formik.touched.accessStartDate : formik.touched.accessEndDate;
    const aERrror = (fieldName === "accessStartDate") ? formik.errors.accessStartDate : formik.errors.accessEndDate;
    //const icon      = ((!wdpUtil.isNullorUndefined(aERrror) && aERrror!.length !== 0) && (!wdpUtil.isNullorUndefined(aTouched) && aTouched === true))?'close' : 'calendar';
    return (
      <CustomFmF name={fieldName}
        value={aDt}
        //onChange={formik.handleChange}
        onChange={(event: any) => onDateChange(event)}
        onBlur={(event: any) => onDateBlur(event)}
        error={aTouched && aERrror}
      />
    );
  }
  ////////////////////////////////////////////////////////////////////////////////////////////////
  // Main return
  ////////////////////////////////////////////////////////////////////////////////////////////////
  return (
    <div className="users-detials-wrap">
      {progressMsg === '' &&
        <div className="users-detials-content">
          <form onSubmit={formik.handleSubmit}>
            <section className="field">
              <section className="label-wrapper">
                <label htmlFor="firstName">First name</label>
                <span className="required">* <span>(required)</span></span>
              </section>
              {/* This input is required to hide input suggestions on Chrome */}
              <input style={{ display: "none" }} autoComplete="on" />
              <TextField id="outlined-basic"
                variant="outlined"
                fullWidth={true}
                inputProps={{
                  autoComplete: "new-password"
                }}
                onChange={(e) => {
                  formik.handleChange(e)
                }}
                onBlur={(e) => {
                  onNamesBlur();
                  formik.handleBlur(e);
                }}
                value={formik.values.firstName}
                focused={true}
                name="firstName"
                error={formik.touched.firstName && Boolean(formik.errors.firstName)}
              />
              {formik.touched.firstName && Boolean(formik.errors.firstName) &&
                <section className="error">
                  <GoabIcon type="warning" theme="filled" size="small" />
                  <span > {formik.errors.firstName}</span>
                </section>
              }
            </section>

            <section className="field">
              <section className="label-wrapper">
                <label htmlFor="middleName">Middle name</label>
              </section>
              <TextField id="outlined-basic"
                variant="outlined"
                fullWidth={true}
                inputProps={{
                  autoComplete: "new-password"
                }}
                onChange={(e) => {
                  formik.handleChange(e)
                }}
                onBlur={(e) => {
                  onNamesBlur();
                  formik.handleBlur(e);
                }}
                value={formik.values?.middleName as string}
                name="middleName"
                error={formik.touched.middleName && Boolean(formik.errors.middleName)}
              />
              {formik.touched.middleName && Boolean(formik.errors.middleName) &&
                <section className="error">
                  <GoabIcon type="warning" theme="filled" size="small" />
                  <span > {formik.errors.middleName}</span>
                </section>
              }
            </section>

            <section className="field">
              <>
                <section className="label-wrapper">
                  <label htmlFor="lastName">Last name</label>
                  <span className="required">* <span>(required)</span></span>
                </section>
                <TextField id="outlined-basic"
                  variant="outlined"
                  fullWidth={true}
                  inputProps={{
                    autoComplete: "new-password"
                  }}
                  onChange={(e) => {
                    formik.handleChange(e)
                  }}
                  onBlur={(e) => {
                    onNamesBlur();
                    formik.handleBlur(e);
                  }}
                  value={formik.values.lastName}
                  name="lastName"
                  error={formik.touched.lastName && Boolean(formik.errors.lastName)}
                />
                {formik.touched.lastName && Boolean(formik.errors.lastName) &&
                  <section className="error">
                    <GoabIcon type="warning" theme="filled" size="small" />
                    <span > {formik.errors.lastName}</span>
                  </section>
                }
              </>
            </section>

            <section className="field">
              <section className="label-wrapper">
                <label htmlFor="displayName">Display name</label>
                <span className="required">* <span>(required)</span></span>
              </section>
              <TextField id="outlined-basic"
                variant="outlined"
                fullWidth={true}
                inputProps={{
                  autoComplete: "new-password"
                }}
                onChange={(e) => {
                  formik.handleChange(e);
                  const value = e?.target?.value;
                  if (value !== formik.values?.displayName) {
                    // real change..user is typing ..this is to prevent displayname Suggestion
                    if (value && value.length) {
                      setDisplayNameSuggEnable(false);
                    } else {
                      //clean
                      setDisplayNameSuggEnable(true);
                    }
                  }
                }}
                onBlur={(e) => {
                  if (formik.values.displayName === "") {
                    // Why: user Entered a FName,MName and LastName and left DName empty(focusout).
                    // this code is to force the suggestion and validate onBlur of the displayName
                    // setField synchronously because we need to validate onNameBlur  right after 
                    const dName = suggestDisplayName(formik.values.firstName, formik.values.middleName, formik.values.lastName);
                    setFieldValueSync("displayName", dName, true);
                  }
                  onNamesBlur();
                  formik.handleBlur(e);
                }}
                value={formik.values?.displayName as string}
                name="displayName"
                error={formik.touched.displayName && Boolean(formik.errors.displayName)}
              />
              <p className="sub-text">Contains only letters and numbers. Maximum length is 15 characters. Suggested Display names are 7 chars of First name, 1st char of Middle name, 7 chars of Last name: 7+1+7.</p>
              {formik.touched.displayName && Boolean(formik.errors.displayName) &&
                <section className="error">
                  <GoabIcon type="warning" theme="filled" size="small" />
                  <span > {formik.errors.displayName}</span>
                </section>
              }
            </section>
            <section className="field">
              <section className="label-wrapper">
                <label htmlFor="email">Username (email)</label>
                <span className="required">* <span>(required)</span></span>
              </section>
              <TextField id="outlined-basic"
                variant="outlined"
                fullWidth={true}
                inputProps={{
                  autoComplete: "new-password"
                }}
                onChange={(e) => {
                  formik.handleChange(e)
                }}
                onBlur={(e) => {
                  if (userId === 'new') {
                    onEmailBlur();
                  }
                  formik.handleBlur(e)

                }}
                value={formik.values.email}
                name="email"
                disabled={userId !== "new"}
                error={formik.touched.email && Boolean(formik.errors.email)}
              />
              {formik.touched.email && Boolean(formik.errors.email) &&
                <section className="error">
                  <GoabIcon type="warning" theme="filled" size="small" />
                  <span > {formik.errors.email}</span>
                </section>
              }
            </section>

            <section className="field">
              <section className="label-wrapper">
                <label htmlFor="phone">Phone</label>
              </section>
              <TextField id="outlined-basic"
                variant="outlined"
                fullWidth={true}
                inputProps={{
                  autoComplete: "new-password"
                }}
                onChange={(e) => {
                  formik.handleChange(e)
                }}
                onBlur={(e) => {
                  formik.handleBlur(e)
                }}
                value={formik.values.phone as string}
                name="phone"
                error={formik.touched.phone && Boolean(formik.errors.phone)}
              />
              {formik.touched.phone && Boolean(formik.errors.phone) &&
                <section className="error">
                  <GoabIcon type="warning" theme="filled" size="small" />
                  <span > {formik.errors.phone}</span>
                </section>
              }
            </section>

            <section className="field">
              <section className="label-wrapper">
                <label htmlFor="organization">Organization</label>
                <span className="required">* <span>(required)</span></span>
              </section>
              <TextField id="outlined-basic"
                variant="outlined"
                fullWidth={true}
                inputProps={{
                  autoComplete: "new-password"
                }}
                onChange={(e) => {
                  formik.handleChange(e)
                }}
                onBlur={(e) => {
                  formik.handleBlur(e)
                }}
                value={formik.values.organization}
                name="organization"
                error={formik.touched.organization && Boolean(formik.errors.organization)}
              />
              {formik.touched.organization && Boolean(formik.errors.organization) &&
                <section className="error">
                  <GoabIcon type="warning" theme="filled" size="small" />
                  <span > {formik.errors.organization}</span>
                </section>
              }
            </section>
            <section className="field">
              <section className="label-wrapper">
                <label htmlFor="usernameAdministeredBy">Username administered by</label>
                <span className="required">* <span>(required)</span></span>
              </section>
              <div onBlur={(e) => { formik.handleBlur(e) }}>
                <GoabDropdown name="usernameAdministeredBy"
                  width="700px"
                  error={formik.touched.usernameAdministeredBy && Boolean(formik.errors.usernameAdministeredBy)}
                  onChange={(detials: GoabDropdownOnChangeDetail) => { formik.handleChange({ target: { name: detials.name, value: detials.value } }) }}

                  value={formik.values.usernameAdministeredBy ? formik.values.usernameAdministeredBy.toString() : ""}>
                  {myAppCtx?.userAdminByList.map((item: any, index) => <GoabDropdownItem key={index} value={item} label={item} />)}
                </GoabDropdown>
              </div>
              {formik.touched.usernameAdministeredBy && Boolean(formik.errors.usernameAdministeredBy) &&
                <section className="error">
                  <GoabIcon type="warning" theme="filled" size="small" />
                  <span > {formik.errors.usernameAdministeredBy}</span>
                </section>
              }
            </section>

            <section className="field">
              <section className="label-wrapper">
                <label htmlFor="localGovernmentId">Local government</label>
              </section>
              <Autocomplete multiple={false} selectOnFocus={true} clearOnBlur={true} sx={{ width: 700 }} id='localGovernmentId' data-testid={`ud_localGovernmentId`}
                renderInput={(params) => <TextField {...params} label="" placeholder={"Select local government"} />}
                options={myAppCtx?.localGovsList.map(i => i.id).filter(f => f !== 0 /*exclude (Blank) */) as number[]}
                getOptionLabel={(option) => myAppCtx?.localGovsList.find((i: any) => i.id === option)?.description as string}
                //filterOptions={filterOptions}
                defaultValue={null}
                value={formik.values.localGovernmentId}
                onChange={(_event: any, newValue: number | null) => { formik.handleChange({ target: { name: 'localGovernmentId', value: newValue } }) }}
                inputValue={localGovInputValue}
                onInputChange={(_event, newInputValue) => { setlocalGovInputValue(newInputValue) }}

                onBlur={(e: any) => formik.handleBlur(e)}
                //error={formik.touched.localGovernmentId && Boolean(formik.errors.localGovernmentId)}
                isOptionEqualToValue={(option, value) => option === value}
              />
            </section>
            <section className="field access-ended">
              <section className="label-wrapper">
                <label htmlFor="accessEndDate">Access ended ?</label>
              </section>
              <section>
                <RadioGroup row
                  aria-labelledby="demo-radio-buttons-group-label"
                  defaultValue="female"
                  name="accessEnded"
                  value={formik.values.accessEnded}
                  onBlur={(e) => {
                    formik.handleBlur(e);
                  }}
                  onChange={(event) => {
                    setShowModal({
                      cb: (cancelled = true) => {
                        //samerconst todayDt = zonedTimeToUtc(startOfDay(new Date()), tz);
                        const todayDt = dayjs().tz(tz).startOf('day');
                        if (cancelled === true) {
                          const rValue = event.target.value === "Yes" ? "No" : "Yes";
                          formik.setFieldValue("accessEnded", rValue);
                        } else {
                          formik.handleChange(event);
                          if (event.target.value === "Yes") {
                            setFieldValueSync("accessEndDate", todayDt.toISOString(), true);
                            //formik.setFieldTouched("accessEndDate", true, false);
                            //formik.validateForm({ ...formik.values, ["accessEndDate"]: todayDt.toISOString() });
                          } else {
                            formik.setFieldValue("accessEndDate", undefined);
                          }
                        }
                      }, show: true
                    });
                  }}
                >
                  <FormControlLabel disabled={formik.values.accessEnded === 'Yes'} value="Yes" control={<Radio />} label="Yes" />
                  <FormControlLabel disabled={formik.values.accessEnded === 'Yes'} value="No" control={<Radio />} label="No" />
                </RadioGroup>
              </section>
              <p className="sub-text">Sets the access end date to today, and removes user access immediately.</p>
              <GoabModal
                open={showModal.show}
                maxWidth="480px"
                actions={
                  <GoabButtonGroup alignment="end">
                    <GoabButton testId='ud-access-ended-modal-no' type="secondary" onClick={() => {
                      showModal.cb();
                      setShowModal({ cb: () => { }, show: false });
                    }}>No, Cancel</GoabButton>
                    <GoabButton testId='ud-access-ended-modal-yes' onClick={() => {
                      showModal.cb(false);
                      setShowModal({ cb: () => { }, show: false })
                    }}>Yes, I do</GoabButton>
                  </GoabButtonGroup>
                }
              >
                {formik.values.accessEnded === "Yes" ?
                  <p>Are you sure you want to give access to {formik.values.firstName} {formik.values.lastName}</p>
                  :
                  <p>Are you sure you want to end access for {formik.values.firstName} {formik.values.lastName}</p>
                }
              </GoabModal>
            </section>

            <div className="date-grid field">
              <section>
                <section className="label-wrapper">
                  <label htmlFor="accessStartDate">Access start date</label>
                  <span className="required">* <span>(required)</span></span>
                </section>
                <div>
                  <section className="date-field">
                    {populateDT('accessStartDate')}
                  </section>
                  <span className="sub-text">00:00:00&nbsp;AM</span>
                </div>
                {formik.touched.accessStartDate && formik.errors.accessStartDate &&
                  <section className="error">
                    <GoabIcon type="warning" theme="filled" size="small" />
                    <span > {formik.errors.accessStartDate as any}</span>
                  </section>
                }
              </section>
              <section>
                <section className="label-wrapper">
                  <label htmlFor="accessEndDate">Access end date</label>
                </section>
                <div>
                  <section className="date-field">
                    {populateDT('accessEndDate')}
                  </section>
                  <span className="sub-text">23:59:59&nbsp;PM</span>
                </div>
                {formik.touched.accessEndDate && formik.errors.accessEndDate &&
                  <section className="error">
                    <GoabIcon type="warning" theme="filled" size="small" />
                    <span > {formik.errors.accessEndDate as any}</span>
                  </section>
                }
              </section>
            </div>

            {/* {formik.values?.createdTimestamp &&
                            <section className="field">
                                <section className="label-wrapper">
                                    <label htmlFor="accessEndDate">Created at</label>
                                </section>
                                <span>{format(new Date(formik.values?.createdTimestamp as number), 'yyyy-MM-dd    HH:mm:ss')}</span>
                            </section>
                        } */}

            <section className="field" onBlur={(e) => { formik.handleBlur(e) }}>
              <section className="label-wrapper">
                <label htmlFor="remarks">Remarks</label>
              </section>
              <GoabTextArea
                onChange={(detials: GoabTextAreaOnChangeDetail) => { formik.handleChange({ target: { name: detials.name, value: detials.value } }) }}
                value={formik.values.remarks as string}
                name="remarks"
                error={!!formik.errors.remarks}
                width="700px"
              />
              {formik.touched.remarks && formik.errors.remarks &&
                <section className="error">
                  <GoabIcon type="warning" theme="filled" size="small" />
                  <span > {formik.errors.remarks}</span>
                </section>
              }
            </section>
            <section className="save">
              <button className="save-button" data-testid="ud-page-save" type="submit"
              //disabled={!formik.isValid || !formik.dirty }
              //disabled={!formik.isValid || (Object.keys(formik.touched).length === 0 )}
              >Save</button>
              {/* <GoabButton type="submit" onClick={() => { (formEl.current as any).submit() }}>Save</GoabButton> */}
              <GoabSpacer hSpacing="s"></GoabSpacer>{toastOpen}
              <GoabButton testId="ud-page-cancel" onClick={() => setShowCancelModal(true)} type="secondary">Cancel</GoabButton>
            </section>
          </form >
          <Toast open={toastOpen} type={toastProp.type} size={toastProp.size} msg={toastProp.msg} onClose={handleToastClose} >
          </Toast>
          <GoabModal heading="" open={showCancelModal} maxWidth="30vw"
            actions={
              <GoabButtonGroup alignment="end">
                <GoabButton testId='ud-cancel-modal-no' type='secondary' onClick={() => { setShowCancelModal(false); }}>No, continue editing</GoabButton>
                <GoabButton testId='ud-cancel-modal-yes' type='primary' onClick={() => { navigate("/") }}>Yes, I am sure</GoabButton>
              </GoabButtonGroup>
            }
          >
            <p>Are you sure you want to discard the changes?</p>
          </GoabModal>
        </div >
      }
      {/* Circular Progress as a layer  must be child of the page div */}
      {progressMsg !== "" && <GoabCircularProgress variant="fullscreen" size="large" message={progressMsg} visible={true} />}
    </div>
  );
}